import { render, staticRenderFns } from "./AdminMembersOfInstitutions.vue?vue&type=template&id=8f338864"
import script from "./AdminMembersOfInstitutions.vue?vue&type=script&lang=js"
export * from "./AdminMembersOfInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports